/** Tarayıcı / OS etiketi (login uyarı metni) */
export function getDeviceLabel() {
  if (typeof navigator === "undefined") return "Bu cihaz";
  const ua = navigator.userAgent || "";

  let browser = "Tarayıcı";
  if (/Edg\//i.test(ua)) browser = "Edge";
  else if (/Chrome\//i.test(ua)) browser = "Chrome";
  else if (/Firefox\//i.test(ua)) browser = "Firefox";
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = "Safari";

  let os = "Cihaz";
  if (/Windows NT/i.test(ua)) os = "Windows";
  else if (/Mac OS X/i.test(ua)) os = "macOS";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad/i.test(ua)) os = "iOS";
  else if (/Linux/i.test(ua)) os = "Linux";

  return `${browser} / ${os}`;
}

export async function fetchLoginDeviceInfo(apiBase) {
  try {
    const res = await fetch(`${apiBase}/auth/remember`, { credentials: "include" });
    if (!res.ok) throw new Error("info failed");
    const data = await res.json();
    return {
      ipAddress: data.ip_address || "—",
      deviceLabel: data.device_label || getDeviceLabel(),
    };
  } catch {
    return {
      ipAddress: "—",
      deviceLabel: getDeviceLabel(),
    };
  }
}

export const REMEMBER_DAY_OPTIONS = [
  { days: 1, label: "1 gün" },
  { days: 10, label: "10 gün" },
  { days: 30, label: "30 gün" },
];
